<template>
  <fetch-artwork-list :query="query" :api="api">
    <template v-slot:default="{ state, artworks, pagination, sync }">
      <div>
        <div class="container px-20">
          <the-exhibit-sets/>
        </div>

        <selected-filter-panel class="container px-20 mb-32"/>
        <div class="container flex items-start px-20 pb-32">
          <div class="w-fit">
            <the-filter-panel-desktop class="filter-panel mr-60 mb-30"/>

            <the-gallery-desktop-exhibit-grid/>
          </div>
          <div class="gallery-content">
            <div class="text-right mb-26">
              <div v-if="page.startsWith('/artists/')" class="float-left">
                <h2 class="text-dark-gray text-16 md:text-18">
                  All Artworks By <span class="text-black">"{{ artistName }}"</span>
                </h2>
              </div>

              <div v-else class="float-left">
                <h1 v-if="query.search" class="text-dark-gray text-16 md:text-18">
                  Artworks with <span class="text-black">"{{ query.search }}"</span>
                </h1>
                <h1 v-else class="text-dark-gray text-16 md:text-18">
                  All Artworks
                </h1>
              </div>
              <a href="/followed-artists" class="mr-24 focus:outline-none">
                FOLLOWED ARTISTS
                <i class="ml-4 fas fa-users text-orange"></i>
              </a>
              <a href="/favorites" class="mr-24 focus:outline-none">
                MY FAVORITES
                <i class="ml-4 fas fa-heart text-orange"></i>
              </a>
              <sort-button></sort-button>
            </div>
            <artwork-grid-loader :state="state">
              <artwork-grid :artworks="artworks">
                <template v-slot:default="{ artwork }">
                  <artwork-card
                    class="mb-30 lg:mb-56"
                    :artwork="artwork"
                    @update:artwork="sync(artwork, $event)">
                  </artwork-card>
                </template>
              </artwork-grid>
            </artwork-grid-loader>
            <artwork-pagination
              v-if="state === 'loaded'"
              :pagination="pagination"
              @navigated="$listeners.navigated">
            </artwork-pagination>
          </div>
        </div>
      </div>
    </template>
  </fetch-artwork-list>
</template>
<script>
import ArtworkGridLoader from '../../ArtworkGridLoader.vue'
import ArtworkGrid from '../../Universal/ArtworkGrid.vue'
import TheFilterPanelDesktop from '../../TheFilterPanelDesktop.vue'
import ArtworkPagination from '../../ArtworkPagination.vue'
import ArtworkCard from '../../Universal/GridLoader/Cards/ArtworkCard.vue'
import PaginationProgress from '../../PaginationProgress.vue'
import SortButton from '../../Universal/SortButton.vue'
import FetchArtworkList from '../../FetchArtworkList.vue'
import SelectedFilterPanel from '../../SelectedFilterPanel.vue'
import TheExhibitSets from "./TheExhibitSets.vue";
import TheGalleryDesktopExhibitGrid from "./TheGalleryDesktopExhibitGrid.vue";

export default {
  components: {
    TheGalleryDesktopExhibitGrid,
    TheExhibitSets,
    ArtworkGridLoader,
    ArtworkGrid,
    TheFilterPanelDesktop,
    ArtworkPagination,
    ArtworkCard,
    PaginationProgress,
    SortButton,
    FetchArtworkList,
    SelectedFilterPanel,
  },

  data() {
    return{
      isLoading: true,
    }
  },

  inject: {
    query: 'query',
    api: 'api',
  },

  computed: {
    page () {
      return window.location.pathname
    },

    artistName () {
      return window.slugToHumanString(this.query.artist)
    },
  },
}
</script>

<style scoped>
.filter-panel {
  width: 300px;
}

.gallery-content {
  width: calc(100% - 360px);
}

.exhibit-card:not(:last-child) {
  margin-bottom: 16px;
}
</style>
